<template>
  <div class="flex flex-column" id="upload_document_template">
    <action-button :title="actionBtnTitle" :loading="loading" @click="actionTriggered" role='secondary'/>
    <input type="file" ref="fileInput" id="file" accept=".docx" class="clip">
  </div>
</template>

<script>
import ActionButton from '@/components/ui/Button.vue'
import fileReader from '@/composables/fileReader'
import { DataService } from '@/services/DataService.js'

export default {
  components: {
    ActionButton
  },
  setup (props) {
    const { bindFileInput, selectFile } = fileReader()
    return {
      bindFileInput,
      selectFile
    }
  },
  mounted () {
    this.bindFileInput(this.$refs.fileInput)
  },
  data () {
    return {
      actionBtnTitle: 'Загрузить',
      loading: false
    }
  },
  methods: {
    actionTriggered () {
      return this.selectFile(({ file, name }) => {
        this.loading = true
        return DataService.createDocumentTemplate({ file: file, title: name })
          .then(({ data: { createDocumentTemplate } }) => {
            this.$emit('save', createDocumentTemplate)
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
